/* ══════════════════════════════════════════════════════════
   ELLIE'S BARK BITES — product page behaviour
   Its own deferred asset (§5.6) so a throw in any section's
   inline JS can never kill the gallery or the buy box.
   ══════════════════════════════════════════════════════════ */
(function () {
  'use strict';
  var EBB = window.EBB = window.EBB || {};
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function money(c) { return EBB.money ? EBB.money(c) : '$' + (c / 100).toFixed(2); }
  function num(v, d) { var n = parseFloat(v); return isNaN(n) ? d : n; }

  /* ─────────── GALLERY ─────────── */
  function initGallery(root) {
    $$('[data-ebb-gallery]:not([data-gal-ready])', root).forEach(function (gal) {
      gal.setAttribute('data-gal-ready', '1');
      var track = $('.gal-track', gal);
      var slides = $$('figure', track);
      var thumbs = $$('.gal-thumbs button', gal);
      var dots = $$('.gal-dots i', gal);
      if (!track || !slides.length) return;
      var i = 0;

      function go(n) {
        i = (n + slides.length) % slides.length;
        track.style.transform = 'translateX(' + (-i * 100) + '%)';
        thumbs.forEach(function (b, k) { b.classList.toggle('on', k === i); b.setAttribute('aria-current', String(k === i)); });
        dots.forEach(function (d, k) { d.classList.toggle('on', k === i); });
        /* keep the active thumbnail in view. This used to be phone-only because
           desktop wrapped its thumbnails into a grid; now that both scroll, an
           arrow press on image seven has to bring thumbnail seven along. The
           scrollBy is a no-op when everything already fits. */
        var rail = $('.gal-thumbs', gal);
        if (rail && thumbs[i]) {
          var t = thumbs[i];
          var delta = t.offsetLeft - rail.scrollLeft - (rail.clientWidth - t.offsetWidth) / 2;
          if (Math.abs(delta) > 1) rail.scrollBy({ left: delta, behavior: reduced ? 'auto' : 'smooth' });
        }
      }
      gal.__go = go;
      gal.__byMedia = function (mediaId) {
        if (!mediaId) return;
        for (var k = 0; k < slides.length; k++) {
          if (slides[k].getAttribute('data-media-id') === String(mediaId)) { go(k); return; }
        }
      };

      gal.addEventListener('click', function (e) {
        var t = e.target.closest('.gal-thumbs button');
        if (t) { go(parseInt(t.getAttribute('data-i'), 10) || 0); return; }
        if (e.target.closest('[data-gal-next]')) { go(i + 1); return; }
        if (e.target.closest('[data-gal-prev]')) { go(i - 1); }
      });
      gal.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(i + 1); }
        if (e.key === 'ArrowLeft') { e.preventDefault(); go(i - 1); }
      });
      var main = $('.gal-main', gal), x0 = null;
      if (main) {
        main.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        main.addEventListener('touchend', function (e) {
          if (x0 === null) return;
          var dx = e.changedTouches[0].clientX - x0;
          if (Math.abs(dx) > 40) go(i + (dx < 0 ? 1 : -1));
          x0 = null;
        }, { passive: true });
      }
      go(0);
    });
  }

  /* ─────────── BUY BOX (variants, packs, qty, price) ─────────── */
  function initBuy(root) {
    $$('[data-ebb-buy]:not([data-buy-ready])', root).forEach(function (buy) {
      buy.setAttribute('data-buy-ready', '1');
      var dataEl = $('[data-ebb-variants]', buy);
      var variants = [];
      try { variants = JSON.parse(dataEl ? dataEl.textContent : '[]') || []; } catch (e) { variants = []; }
      if (!variants.length) return;

      var form = $('.ebb-add-form', buy);
      var idInput = form ? form.querySelector('input[name="id"]') : null;
      var qtyInput = form ? form.querySelector('input[name="quantity"]') : null;
      var atc = $('[data-atc]', buy);
      var atcLabel = atc ? atc.querySelector('[data-atc-label]') : null;
      var priceEl = $('[data-price]', buy);
      var wasEl = $('[data-price-was]', buy);
      var saveEl = $('[data-price-save]', buy);
      var noteEl = $('[data-price-note]', buy);
      var stockEl = $('[data-stock]', buy);
      var shipEl = $('[data-ship-gap]', buy);
      var gal = $('[data-ebb-gallery]');
      var bar = $('[data-sticky-bar]');
      var threshold = num(buy.getAttribute('data-free-ship'), 0);
      var unitWord = buy.getAttribute('data-unit-word') || 'bag';
      var packName = (buy.getAttribute('data-pack-option') || '').toLowerCase();
      var current = variants.filter(function (v) { return String(v.id) === String(idInput && idInput.value); })[0] || variants[0];
      var chosen = (current.options || []).slice();

      function packSize(v) {
        if (!packName) return 1;
        var idx = (buy.getAttribute('data-pack-index') || '0') | 0;
        var m = /(\d+)/.exec(String((v.options || [])[idx] || ''));
        return m ? parseInt(m[1], 10) : 1;
      }
      var basePer = (function () {
        var singles = variants.filter(function (v) { return packSize(v) === 1; });
        var v = singles[0] || variants[0];
        return v.price / (packSize(v) || 1);
      })();

      function match() {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i], ok = true;
          for (var k = 0; k < chosen.length; k++) {
            if (String((v.options || [])[k]) !== String(chosen[k])) { ok = false; break; }
          }
          if (ok) return v;
        }
        return null;
      }

      function paintOptions() {
        $$('[data-opt-value]', buy).forEach(function (btn) {
          var k = parseInt(btn.getAttribute('data-opt-index'), 10);
          var val = btn.getAttribute('data-opt-value');
          btn.classList.toggle('on', String(chosen[k]) === String(val));
          btn.setAttribute('aria-checked', String(String(chosen[k]) === String(val)));
          var probe = chosen.slice(); probe[k] = val;
          var exists = variants.some(function (v) {
            for (var q = 0; q < probe.length; q++) {
              if (q === k) { if (String((v.options || [])[q]) !== String(val)) return false; }
            }
            return true;
          });
          var sellable = variants.some(function (v) {
            var all = true;
            for (var q = 0; q < probe.length; q++) {
              if (String((v.options || [])[q]) !== String(probe[q])) { all = false; break; }
            }
            return all && v.available;
          });
          btn.classList.toggle('is-off', exists && !sellable);
        });
      }

      var deepLinkedVariant = false;
      try { deepLinkedVariant = new URLSearchParams(window.location.search).has('variant'); } catch (e) {}

      function sync(pushUrl) {
        var v = match();
        var qty = Math.max(1, parseInt(qtyInput ? qtyInput.value : 1, 10) || 1);
        paintOptions();

        if (!v) {
          if (atcLabel) atcLabel.textContent = 'Unavailable';
          if (atc) { atc.disabled = true; }
          if (idInput) idInput.value = '';
          return;
        }
        if (idInput) idInput.value = v.id;
        current = v;

        var n = packSize(v) * qty;
        var total = v.price * qty;
        if (priceEl) priceEl.textContent = money(total);
        var comp = v.compare_at_price && v.compare_at_price > v.price
          ? v.compare_at_price * qty
          : (basePer * packSize(v) > v.price ? Math.round(basePer * packSize(v)) * qty : 0);
        if (wasEl) {
          if (comp > total) { wasEl.hidden = false; wasEl.textContent = money(comp); }
          else wasEl.hidden = true;
        }
        if (saveEl) {
          if (comp > total) { saveEl.hidden = false; saveEl.textContent = 'Save ' + money(comp - total); }
          else saveEl.hidden = true;
        }
        if (noteEl) {
          var base = noteEl.getAttribute('data-base') || '';
          noteEl.textContent = base + (base ? ' · ' : '') + n + ' ' + unitWord + (n > 1 ? 's' : '') + ' total';
        }
        if (stockEl) {
          stockEl.classList.toggle('is-out', !v.available);
          var lbl = stockEl.querySelector('[data-stock-label]');
          if (lbl) lbl.textContent = v.available ? (stockEl.getAttribute('data-in') || 'In stock') : (stockEl.getAttribute('data-out') || 'Sold out');
        }
        if (atc) {
          atc.disabled = !v.available;
          if (atcLabel) atcLabel.textContent = v.available
            ? (atc.getAttribute('data-label') || 'Add to cart')
            : (atc.getAttribute('data-label-out') || 'Sold out');
        }
        /* Opt-in. This countdown was overwriting the trust row's flat-rate
           promise with "$63.00 to free shipping" — a different message from
           the one the announcement bar, the home page and the FAQ all give,
           and computed from this line's total alone, so it ignored whatever
           is already in the cart. Off by default; the static promise stands. */
        if (shipEl && threshold > 0 && buy.getAttribute('data-ship-progress') === 'true') {
          var gap = threshold - total;
          shipEl.textContent = gap > 0 ? money(gap) + ' to free shipping' : 'This order ships free';
        }
        $$('[data-pack]', buy).forEach(function (p) {
          var on = String(p.getAttribute('data-opt-value')) === String(chosen[parseInt(p.getAttribute('data-opt-index'), 10)]);
          p.classList.toggle('on', on);
          p.setAttribute('aria-checked', String(on));
        });
        /* Variant-image sync, but not on arrival. sync() runs once at init to
           paint the pre-selected variant, and that call was dragging the
           gallery onto whatever media that variant carries — which on a
           product whose last image is the size chart meant every visitor
           landed on the size chart instead of the hero shot. Jump only when
           the shopper actually picks an option, or when they arrived on a
           ?variant= deep link and therefore asked for that one. */
        if (gal && gal.__byMedia && v.featured_media_id && (pushUrl || deepLinkedVariant)) {
          gal.__byMedia(v.featured_media_id);
        }
        if (bar) {
          var bp = $('[data-sb-price]', bar);
          if (bp) bp.textContent = money(total) + ' · ' + n + ' ' + unitWord + (n > 1 ? 's' : '');
          var bimg = $('[data-sb-img]', bar);
          if (bimg && v.image) bimg.setAttribute('src', v.image);
          var batc = $('[data-bar-atc]', bar);
          if (batc) {
            batc.disabled = !v.available;
            var bl = batc.querySelector('[data-atc-label]');
            if (bl) bl.textContent = v.available ? (batc.getAttribute('data-label') || 'Add to cart') : 'Sold out';
          }
        }
        if (pushUrl && window.history && history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          history.replaceState({}, '', url.toString());
        }
      }

      buy.addEventListener('click', function (e) {
        var opt = e.target.closest('[data-opt-value]');
        if (opt) {
          e.preventDefault();
          var k = parseInt(opt.getAttribute('data-opt-index'), 10) || 0;
          chosen[k] = opt.getAttribute('data-opt-value');
          sync(true);
          return;
        }
        var step = e.target.closest('[data-qty-step]');
        if (step && qtyInput) {
          e.preventDefault();
          var next = (parseInt(qtyInput.value, 10) || 1) + parseInt(step.getAttribute('data-qty-step'), 10);
          qtyInput.value = Math.min(99, Math.max(1, next));
          sync(false);
        }
      });
      buy.addEventListener('change', function (e) {
        if (qtyInput && e.target === qtyInput) {
          qtyInput.value = Math.min(99, Math.max(1, parseInt(qtyInput.value, 10) || 1));
          sync(false);
        }
        var sel = e.target.closest ? e.target.closest('[data-opt-select]') : null;
        if (sel) { chosen[parseInt(sel.getAttribute('data-opt-index'), 10) || 0] = sel.value; sync(true); }
      });
      /* the sticky bar's button submits the real buy form */
      if (bar) {
        var barAtc = $('[data-bar-atc]', bar);
        if (barAtc && form && !barAtc.__wired) {
          barAtc.__wired = true;
          barAtc.addEventListener('click', function (e) {
            e.preventDefault();
            if (typeof form.requestSubmit === 'function') form.requestSubmit();
            else form.dispatchEvent(new Event('submit', { cancelable: true, bubbles: true }));
          });
        }
      }
      sync(false);
    });
  }

  /* ─────────── STICKY TAB SCROLLSPY ─────────── */
  function initTabs(root) {
    $$('[data-ebb-tabs]:not([data-tabs-ready])', root).forEach(function (nav) {
      nav.setAttribute('data-tabs-ready', '1');
      var tabs = $$('.tab', nav);
      if (!tabs.length || !('IntersectionObserver' in window)) return;
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (en) {
          if (!en.isIntersecting) return;
          tabs.forEach(function (t) {
            t.classList.toggle('is-on', t.getAttribute('href') === '#' + en.target.id);
          });
        });
      }, { rootMargin: '-45% 0px -50% 0px' });
      tabs.forEach(function (t) {
        var href = t.getAttribute('href') || '';
        if (href.charAt(0) !== '#' || href.length < 2) return;
        var sec = document.getElementById(href.slice(1));
        if (sec) obs.observe(sec); else t.hidden = true;
      });
    });
  }

  /* ─────────── FEEDING GUIDE ─────────── */
  function initFeeding(root) {
    $$('[data-ebb-feeding]:not([data-feed-ready])', root).forEach(function (sec) {
      sec.setAttribute('data-feed-ready', '1');
      var pills = $$('.fp', sec);
      if (!pills.length) return;
      var perBag = num(sec.getAttribute('data-per-bag'), 24);
      var unit = sec.getAttribute('data-unit') || 'biscuits';
      function set(btn) {
        pills.forEach(function (b) {
          var on = b === btn;
          b.classList.toggle('is-on', on);
          b.setAttribute('aria-checked', String(on));
        });
        var w = $('[data-feed-w]', sec), n = $('[data-feed-n]', sec),
            u = $('[data-feed-unit]', sec), s = $('[data-feed-sub]', sec), d = $('[data-feed-days]', sec);
        if (w) w.textContent = btn.getAttribute('data-w') || '';
        if (n) n.textContent = btn.getAttribute('data-n') || '';
        if (u) u.textContent = unit;
        if (s) s.textContent = btn.getAttribute('data-sub') || '';
        if (d) {
          var per = num(btn.getAttribute('data-per'), 2);
          d.textContent = Math.max(1, Math.round(perBag / (per || 1))) + ' days';
        }
      }
      sec.addEventListener('click', function (e) {
        var b = e.target.closest('.fp');
        if (b) { e.preventDefault(); set(b); }
      });
      set(pills.filter(function (p) { return p.classList.contains('is-on'); })[0] || pills[0]);
    });
  }

  /* "Read more" now lives in ebb-common.js so the story section can use the
     same behaviour. One implementation, called from both. */
  function initClamp(root) {
    if (window.EBB && window.EBB.initClamp) window.EBB.initClamp(root);
  }

  /* ─────────── PRODUCT RECOMMENDATIONS (lazy — the object is empty on a normal render) ─────────── */
  function initRecommend(root) {
    $$('[data-ebb-recommend]:not([data-rec-done])', root).forEach(function (sec) {
      var url = sec.getAttribute('data-url');
      if (!url) return;
      sec.setAttribute('data-rec-done', '1');
      fetch(url)
        .then(function (r) { return r.ok ? r.text() : Promise.reject(r.status); })
        .then(function (html) {
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var fresh = doc.querySelector('[data-ebb-recommend] .prods');
          var current = sec.querySelector('.prods');
          if (fresh && current && fresh.children.length) {
            current.replaceWith(fresh);
            if (window.EBB && window.EBB.init) window.EBB.init(sec);
          }
        })
        .catch(function () { /* the server-rendered fallback stays in place */ });
    });
  }

  EBB.initProduct = function (root) {
    root = root || document;
    try { initRecommend(root); } catch (e) {}
    try { initGallery(root); } catch (e) {}
    try { initBuy(root); } catch (e) {}
    try { initTabs(root); } catch (e) {}
    try { initFeeding(root); } catch (e) {}
    try { initClamp(root); } catch (e) {}
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { EBB.initProduct(document); });
  } else {
    EBB.initProduct(document);
  }
  document.addEventListener('shopify:section:load', function (e) { EBB.initProduct(e.target); });
})();
